import { render, staticRenderFns } from "./company-documents-card.vue?vue&type=template&id=04a44142&"
import script from "./company-documents-card.vue?vue&type=script&lang=js&"
export * from "./company-documents-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports